module.exports = __webpack_public_path__ + "media/images/dd-logo-0d57dbe35535e08b1b543eb250a7eee5.jpg";